import React from 'react';

/**
 * Browser-window frame around the live preview, with the "illustrative only" notice.
 * @param {{address: string, title: string, children: React.ReactNode}} props
 */
export default function PreviewFrame({ address, title, children }) {
  return (
    <div>
      <div className="overflow-hidden rounded-lg border border-white/20 shadow-lg" data-testid="pp-preview">
        <div className="flex items-center gap-1.5 bg-slate-300 px-3 py-2">
          <span className="h-2.5 w-2.5 rounded-full bg-red-400" /><span className="h-2.5 w-2.5 rounded-full bg-yellow-400" /><span className="h-2.5 w-2.5 rounded-full bg-green-500" />
          <span className="ml-3 max-w-[60%] truncate rounded-t bg-white px-3 py-1 text-[11px] text-slate-700">{title || 'Your page title'}</span>
        </div>
        <div className="bg-slate-200 px-3 py-1.5">
          <div className="truncate rounded-full bg-slate-300 px-3 py-1 text-[11px] text-slate-700">https://{address}</div>
        </div>
        <div className="min-h-[300px] max-h-[480px] overflow-y-auto bg-white">{children}</div>
      </div>
      <p className="mt-2 rounded bg-rose-500 px-3 py-1.5 text-center text-[11px] text-white">
        The preview is for illustrative purposes only and may not fully reflect the final appearance or functionality of your page.
      </p>
    </div>
  );
}
